export const mixinUserbehv = {
  methods: {
    setUserbehv(item_id, bhv_type, sku, bhv_value) {
      if (
        !sessionStorage.getItem("trace_info") ||
        !sessionStorage.getItem("rn")
      ) {
        return;
      }
      this.$reqPost("api/ecomm/userbehv", {
        trace_info: sessionStorage.getItem("trace_info"),
        rn: sessionStorage.getItem("rn"),
        item_id: item_id, //product_id
        bhv_type: bhv_type, //stay time、click 1、cart null、buy num
        bhv_time: Math.floor(Date.now() / 1000),
        bhv_value: bhv_value,
        sku: sku
      }).then(res => {
        if (res.data.success) {
          //
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/userbehv.js